<template>
  <div class="l-info-column">
      <h4 class="title">
        {{ title }}
      </h4>
      <p class="content">
        {{ content }}
        <slot />
      </p>
  </div>
</template>

<script>
export default {
    name: 'l-info-column',
    props:{
        title: {
          default: ''
        },
        content:{
          default: ''
        }
    }

}
</script>
<style lang="scss" scoped>
.l-info-column{
  display: inline-block;
  box-sizing: border-box;

  & + &{
    margin-top: 20px;
  }
  
  .title{
    @include font_info_title;
    position: relative;
    padding: 10px 0;

    &::after{
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 22px;
      height: 2px;
      background: $main_color;
    }
    
  }
  
  .content{
    @include font_content;
  }
  
}

</style>